import { createFileRoute } from '@tanstack/react-router';

import SetupTraining from '~/setup/training/SetupTraining';

export const Route = createFileRoute('/training/create')({
  component: SetupTraining,
});
